import clsx from 'clsx'
import React, { FC, MutableRefObject } from 'react'

import SvgAngleLeft from '@Assets/SVG/AngleLeft'
import { useHorizontalCarouselButton } from '@Shared/Components/Carousels/HorizontalCarousel/hooks/UseHorizontalCarouselButton'

import styles from './HorizontalCarouselRightArrow.module.scss'

export interface HorizontalCarouselRightArrowProps {
  buttonClassName?: string
  buttonFloat: boolean
  buttonMoveOneField: boolean
  carouselRef: MutableRefObject<HTMLDivElement | null>
  gap: number
  unevenChildWidth?: boolean

}

export const HorizontalCarouselRightArrow: FC<HorizontalCarouselRightArrowProps> = ({
  buttonClassName,
  buttonFloat,
  buttonMoveOneField,
  carouselRef,
  gap,
  unevenChildWidth,
}) => {
  const { getScrollMovement, getScrollMovementRightForUneven } = useHorizontalCarouselButton(carouselRef, buttonMoveOneField, gap)

  const getRight = () => {
    if (!carouselRef.current) {
      return 0
    }
    if (unevenChildWidth) {
      const children = Array.from(carouselRef.current?.children || [])
      return getScrollMovementRightForUneven(children)
    }
    const moveField = getScrollMovement((a, b) => a + b)
    return moveField > carouselRef.current!.scrollWidth ? carouselRef.current!.scrollWidth : moveField
  }

  return (
    <button
      // TODO: use translation for aria-label
      aria-label="Right"
      className={clsx(styles.horizontalCarouselRightArrow, buttonFloat && styles.float, buttonClassName)}
      onClick={() => carouselRef.current!.scrollTo({
        left: getRight(),
        behavior: 'smooth',
      })}
      type="button"
    >
      <SvgAngleLeft />
    </button>
  )
}
